import { render } from "./Motivacion.vue?vue&type=template&id=2d884db8&scoped=true&ts=true"
import script from "./Motivacion.vue?vue&type=script&lang=ts"
export * from "./Motivacion.vue?vue&type=script&lang=ts"

import "./Motivacion.vue?vue&type=style&index=0&id=2d884db8&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d884db8"]])

export default __exports__